var map = {
	"./doc.svg": 2426,
	"./docx.svg": 6158,
	"./file.svg": 9330,
	"./jpeg.svg": 2234,
	"./jpg.svg": 5317,
	"./jt.svg": 4634,
	"./jt1.svg": 4311,
	"./pdf.svg": 6570,
	"./png.svg": 4757,
	"./rw.svg": 657,
	"./tj.svg": 6926,
	"./xls.svg": 5447,
	"./xlsx.svg": 1261,
	"./zip.svg": 9869,
	"./zizhi.svg": 5406
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8202;